/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { fileModelSchema } from "./fileModelSchema.ts";
import { userDonationListModelSchema } from "./userDonationListModelSchema.ts";
import { z } from "zod";

export const userDonationInfoModelSchema = z.object({
    "userId": z.string().uuid().describe("Идентификатор пользователя"),
"picture": z.lazy(() => fileModelSchema).describe("Аватар").nullable().nullish(),
"nickname": z.string().describe("Псевдоним"),
"phoneNumber": z.string().describe("Номер телефона").nullable().nullish(),
"donations": z.array(z.lazy(() => userDonationListModelSchema)).describe("Список платежей")
    })